export function useProductVariants() {
    onMounted(async () => {
        EventBus.$on(CHANGE_LOCALE_EVENT, load)
        await load()
    })

    onUnmounted(() => {
        EventBus.$off(CHANGE_LOCALE_EVENT, load)
    })

    const app = useNuxtApp()
    const {locale, t} = useI18n()
    const load = async () => {
        if (locale.value !== runtimeStore.productVariantsLocale) await runtimeStore.loadProductVariants()
    }

    const getProductVariantById = productVariantId => {
        const productVariant = runtimeStore.productVariants.find(({id}) => id === productVariantId)
        if (productVariant) {
            productVariant.icon = app.$conf.public.productVariantIcons[productVariantId]
        }
        return productVariant
    }

    return {getProductVariantById}
}
